import { m } from 'framer-motion';
import { Network, Server, Code, Video, Headset, ShieldCheck } from 'lucide-react';

const features = [
  {
    icon: <Server className="w-6 h-6 text-accent" />,
    title: "Вычислительные мощности (Servers)",
    description: "Аренда VPS/VDS на быстрых NVMe дисках, выделенные физические серверы и GPU-инстансы для задач машинного обучения и рендеринга."
  },
  {
    icon: <Network className="w-6 h-6 text-accent" />,
    title: "Инфраструктура и Сети (Network)",
    description: "Проектирование и монтаж локальных сетей (ЛВС), настройка оборудования MikroTik/Cisco, организация защищенных VPN-каналов между филиалами."
  },
  {
    icon: <Code className="w-6 h-6 text-accent" />,
    title: "Разработка (API / Backend)",
    description: "Проектирование серверной архитектуры, создание высоконагруженных API, интеграция корпоративных систем и оптимизация баз данных."
  },
  {
    icon: <Headset className="w-6 h-6 text-accent" />,
    title: "Внедрение и Поддержка (CRM)",
    description: "Настройка и интеграция Bitrix24/amoCRM. IT-аутсорсинг, администрирование серверов (Windows/Linux) и круглосуточная техподдержка."
  },
  {
    icon: <Video className="w-6 h-6 text-accent" />,
    title: "Видеонаблюдение (Video)",
    description: "Проектирование и монтаж систем видеонаблюдения, облачное хранение архивов и настройка удаленного доступа с любых устройств."
  },
  {
    icon: <ShieldCheck className="w-6 h-6 text-accent" />,
    title: "Информационная безопасность",
    description: "Аудит ИТ-инфраструктуры, защита от DDoS-атак, резервное копирование данных и обеспечение бесперебойной работы сервисов."
  }
];

export const Features = () => {
  return (
    <section id="features" className="py-24 bg-[#020617] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <m.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-extrabold text-white mb-4"
          >
            Комплексные ИТ-решения от <span className="text-accent">FIPI.PRO</span>
          </m.h2>
          <m.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg text-slate-400 max-w-2xl mx-auto"
          >
            От аренды надежных серверов до сложной серверной разработки и монтажа локальных сетей в Красноярске.
          </m.p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <m.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-panel p-8 rounded-2xl hover:bg-white/[0.08] transition-colors border border-white/5"
            >
              <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center mb-6 border border-blue-500/20">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-slate-400 leading-relaxed">{feature.description}</p>
            </m.div>
          ))}
        </div>
      </div>
    </section>
  );
};